import { useContext } from 'react'

import { CourseStateContext } from '../state/CourseProvider'

export const useCourse = () => {
  const context = useContext(CourseStateContext)

  if (context === undefined) {
    throw new Error('useCourse must be used within CourseProvider')
  }

  return context
}
